import { Icon } from '@adobe/react-spectrum';

const ChevronRight = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || '6'}
        height={props.height || '6'}
        viewBox="0 0 6 6"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.98538 5.96141C1.7969 5.96141 1.62015 5.88768 1.48733 5.7534C1.35598 5.6201 1.28421 5.44383 1.28567 5.25682C1.28713 5.06981 1.36087 4.89452 1.49368 4.76366L3.27932 2.99999L1.50832 1.25097C1.37551 1.11962 1.30129 0.944334 1.30031 0.757324C1.29885 0.570314 1.37062 0.394044 1.50197 0.261234C1.63478 0.126954 1.81154 0.0527344 2.00051 0.0527344C2.18557 0.0527344 2.36037 0.124514 2.49221 0.254884L4.76711 2.50195C4.90481 2.6416 4.97658 2.81787 4.97512 3.00488C4.97366 3.19189 4.89992 3.36718 4.76711 3.49804L2.47756 5.75976C2.34572 5.88964 2.17093 5.96141 1.98538 5.96141Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};

export default ChevronRight;
